// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KWpz","image":"Header_image__3PXXk","name":"Header_name__3tJaC","info":"Header_info__1vUIT","infoRow":"Header_infoRow__1t80f"};